import { Longhand } from "../longhand.js";
import Base, { compute } from "./border-top-width.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-left-width}
 * @internal
 */
export default Longhand.extend(Base, {
    compute: (borderWidth, style) => {
        const borderStyle = style.computed("border-left-style");
        return compute(borderStyle, borderWidth, style);
    },
});
//# sourceMappingURL=border-left-width.js.map